import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'

import Link from 'components/common/A'
import NowrapDiv from 'components/common/NowrapDiv'
import CursorBox from 'components/common/CursorPointerBox.js'

const ImgRect = styled.div`
  position: relative;
  padding-top: 50%;
  padding-top: ${({ $flat }) => ($flat ? '50%' : '75%')};
`
const Absolute = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
const Img = styled.img`
  ${({ theme, $src, $hasRadius }) => `
    border-radius: ${$hasRadius ? theme.spacing(2.5) : '0'};
    width: 100%;
    height: 100%;
    object-fit: cover;
  `}
`

const StyledNowrapDiv = styled(NowrapDiv)`
  text-align: ${({ $alignRight }) => ($alignRight ? 'right' : 'initial')};
`

const ArticleCard = ({ article, main, sixth }) => {
  if (!article) {
    // TODO: Skeleton
    return (
      <div>
        <ImgRect $flat={!!sixth} />
        <Box mt={4}>
          <Typography variant={main ? 'h4' : 'h6'}>
            <NowrapDiv $lines={3} $fixHeight />
          </Typography>
        </Box>
      </div>
    )
  }

  const image = article?.mediumImage || article?.image

  return (
    <Link href={`/article/${article?.urlId}`}>
      <CursorBox>
        <ImgRect $flat={!!sixth}>
          <Absolute>
            <Img src={image?.url} $hasRadius={!!sixth} />
          </Absolute>
        </ImgRect>
        <Box mt={4} color="text.minus2">
          <Typography variant={main ? 'h4' : 'h6'}>
            <StyledNowrapDiv
              $lines={3}
              $fixHeight={!main}
              $alignRight={!!sixth}
            >
              {article?.title}
            </StyledNowrapDiv>
          </Typography>
        </Box>
      </CursorBox>
    </Link>
  )
}

export default ArticleCard
